export const summarizeNumber = (num: number) => {
    if (num == null) {
        return '';
    }
    if (num < 1000) {
        return num.toString();
    } else if (num < 100000) {
        return ((Math.round(num/100)) / 10).toString() + 'k';
    } else if (num < 1000000) {
        return Math.floor(num/1000).toString() + 'k';
    } else if (num < 1000000000) {
        return (Math.round(num/100000) / 10).toString() + 'M';
    } else if (num < 1000000000000) {
        return (Math.floor(num/100000000) / 10).toString() + 'B';
    }
    return '';
}
